import React from 'react'

const InitialLetters = React.memo(({ classes, name, splitBy}) => {
    let capsName = '';
    capsName = name?.split(splitBy || /\s+/)?.map(item => item[0]?.toUpperCase())?.slice(0,2)?.join('');
    return (
      <>
        {capsName}
      </>
    );
})
export default InitialLetters